/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationUserResponseDto
 */
export interface CreateOrganizationUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    roleId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    roleName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    language: CreateOrganizationUserResponseDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserResponseDto
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrganizationUserResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrganizationUserResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateOrganizationUserResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const CreateOrganizationUserResponseDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type CreateOrganizationUserResponseDtoLanguageEnum = typeof CreateOrganizationUserResponseDtoLanguageEnum[keyof typeof CreateOrganizationUserResponseDtoLanguageEnum];


/**
 * Check if a given object implements the CreateOrganizationUserResponseDto interface.
 */
export function instanceOfCreateOrganizationUserResponseDto(value: object): value is CreateOrganizationUserResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    if (!('roleName' in value) || value['roleName'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function CreateOrganizationUserResponseDtoFromJSON(json: any): CreateOrganizationUserResponseDto {
    return CreateOrganizationUserResponseDtoFromJSONTyped(json, false);
}

export function CreateOrganizationUserResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationUserResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'name': json['name'],
        'roleId': json['roleId'],
        'roleName': json['roleName'],
        'language': json['language'],
        'organizationId': json['organizationId'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'active': json['active'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function CreateOrganizationUserResponseDtoToJSON(json: any): CreateOrganizationUserResponseDto {
    return CreateOrganizationUserResponseDtoToJSONTyped(json, false);
}

export function CreateOrganizationUserResponseDtoToJSONTyped(value?: CreateOrganizationUserResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'language': value['language'],
        'organizationId': value['organizationId'],
        'phone': value['phone'],
        'active': value['active'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

